import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import RechargeModal from '../../RechargeModal';
import AfterPayModal from '../../RechargeModal/AfterPayModal';
import { Modal } from 'antd';
import QrcodeImage from '../../../images/charge-tip-qrcode.png'

const clsPrefix = 'walletCard';

const WalletCard: React.FC<{
  title: string;
  type: string;
  amtWithdraw?: string | number;
  amtAlready: string | number;
  amtOnWay: string | number;
  rechargeble?: boolean;
  showAmtAlready?: boolean;
  balance?: string | number;
  onRechargeSuccess?: () => void;
  isVip?: boolean;
}> = ({ title, type, amtWithdraw, amtAlready, amtOnWay, rechargeble, showAmtAlready = true, balance, onRechargeSuccess, isVip }) => {
  const [rechargeVisible, setRechargeVisible] = useState(false);
  const [afterPaymentVisible, setAfterPaymentVisible] = useState(false);
  const [rechargeValues, setRechargeValues] = useState({
    needInvoice: false,
    rechargeAmount: { amount: 50, otherAmount: undefined },
  });

  function handleWalletManage(id: string) {
    window.location.href = `/v5/withdraw/WalletManage?biztype=${id}`;
  }

  function handleRechargeChange(values) {
    setRechargeValues({ ...rechargeValues, ...values });
  }

  function handleClickRecharge() {
    if(!isVip) return Modal.confirm({
      title: '您的红包功能还未开通，暂时无法充值',
      content: (
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <span>请扫码添加快站工作人员通过审核付费开通功能后继续充值</span>
          <img src={QrcodeImage} alt="" style={{width: '200px'}} />
        </div>
      ),
      okText: '知道了',
    });
    setRechargeVisible(true);
  }

  const cls = classnames(clsPrefix, { [`${clsPrefix}--rechargeble`]: rechargeble });
  return (
    <div className={cls}>
      <div className={`${clsPrefix}-title`}>{title}</div>
      <hr className={`${clsPrefix}-cut`} />
      <div className={`${clsPrefix}-balance`}>
        <span className={`${clsPrefix}-balanceTitle`}>余额（元）</span>
        <span className={`${clsPrefix}-balanceMoney`}>{balance}</span>
      </div>
      <div className={`${clsPrefix}-cash`}>
        {showAmtAlready ? (
          <div className={`${clsPrefix}-canCash`}>
            <span className={`${clsPrefix}-balanceTitle`}>已提现（元）</span>
            <div className={`${clsPrefix}-cashMoney`}>{amtAlready}</div>
          </div>
        ) : null}
        <div className={classnames(`${clsPrefix}-cashing`, { [`${clsPrefix}-cashing--only`]: !showAmtAlready })}>
          <span className={`${clsPrefix}-balanceTitle`}>提现中（元）</span>
          <div className={`${clsPrefix}-cashMoney`}>{amtOnWay}</div>
        </div>
      </div>
      {rechargeble ? (
        <div className={`${clsPrefix}-btn-group`}>
          <span className="recharge-btn" onClick={handleClickRecharge}>
            充值
          </span>
          <span className="withdraw-btn" onClick={() => handleWalletManage(type)}>
            提现
          </span>
        </div>
      ) : (
        <div className={`${clsPrefix}-withdrawBtn`} onClick={() => handleWalletManage(type)}>
          <span>去提现</span>
        </div>
      )}
      <RechargeModal
        visible={rechargeVisible}
        values={rechargeValues}
        // onConfirm={() => {
        //     setRechargeVisible(false)
        //     setAfterPaymentVisible(true)
        // }}
        onCancel={() => setRechargeVisible(false)}
        onChange={handleRechargeChange}
      />
      <AfterPayModal
        visible={afterPaymentVisible}
        onCancel={() => setAfterPaymentVisible(false)}
        onConfirm={() => {
          onRechargeSuccess();
          setAfterPaymentVisible(false);
        }}
      />
    </div>
  );
};

export default WalletCard;
